<div class="outer-container">
  <div class="main-container">
    <mat-card>
      <mat-tab-group animationDuration="150ms">
        <mat-tab *ngFor="let tab of tabs" [label]="tab.title">
          <div class="filter-row">
            <ov-suite-excel-formatter
              [formClass]="formClass"
              [columnData]="columnData"
              (overrideExportEmitter)="fetchData(tab)"
              [overrideExportData]="tab.fetchDownloadData"
              [overrideFetchQuery]="true"
              class="filter-item">
            </ov-suite-excel-formatter>
          </div>
          <ov-suite-clean-table
            #loadTable
            [columnData]="columnData"
            [dataSource]="tab.dataSource"
            emptyMessage="No Log Entries"
          >
          </ov-suite-clean-table>
        </mat-tab>
      </mat-tab-group>
    </mat-card>
  </div>
</div>
